import { render, staticRenderFns } from "./ChooseGroupLayout.vue?vue&type=template&id=e69a8bce&"
import script from "./ChooseGroupLayout.vue?vue&type=script&lang=ts&"
export * from "./ChooseGroupLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports